import React, { useEffect, useRef, useState } from 'react';
import { loadFromLocalStorage, saveToLocalStorage } from '../elements/api/CookieManagement';
import CenterBox from '../elements/centerBox';
import useInterval from '../Hooks/useInterval';
import * as api from '../elements/api/api';
import * as cf from '../elements/api/CoreFunctions';

import * as bm from '../elements/api/BookmarkManagement'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';



function SelectLanguage(props) {

    const [language, setLanguage] = useState("default")

    const closeWindow = () => {
        props.selectLanguage(null);
    }

    const selectLanguage = () => {
        props.selectLanguage(language);
    }

    useEffect( () => {setLanguage(props.languages[0])}
        ,[])


    return (

        <div class="overlay">
            <div class="kasten" onClick={e => e.preventDefault()}>
                <button class="close-btn" onClick={closeWindow}>×</button>
                <h4>This video is available in several languages.</h4>
                <Form.Group className="mb-3 border p-3 rounded">
                    Please select the language:<br></br>

                    <select onChange={(e) => setLanguage(e.target.value)} id="lang" name="lang">
                        <option selected={true} value="default">default</option>
                        {props.languages.map(
                            (lang) => {
                                return (
                                    <option value={lang}>{lang}</option>
                                )
                            }
                        )}
                    </select>
                </Form.Group>
                <Button onClick={selectLanguage} variant="primary">OK</Button>

            </div>
        </div>
    );

}

export default SelectLanguage;